import React, { useState } from 'react';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import MoreBetsOdd from '../../common/MoreBetsOdd';
import { getLabel } from '../../data/labels';
import { classIf, getBetDescription, getConfiguration, getNumberOfColsDesktop, getPrincipaleOPrimoGruppo } from '../../data/utils';
import ButtonsContainer from './ButtonsContainer';
import CashoutLabel from '../../common/CashoutLabel';
import { useFetch, usePoll } from '../../data/fetch/useFetch';
import { parseMatchData } from '../../data/parseMatchData';

function getColsNumber(bet) {
    if (bet.isCompact) {
        let oddsLength = window.xs_ag.betById[`${bet.id}_${bet.handicap}`]?.odds.length ?? window.xs_ag.betById[`${bet.id}_${0}`]?.odds.length ?? 0;
        if (oddsLength > 0) {
            return getNumberOfColsDesktop(oddsLength);
        }
    }
    return getNumberOfColsDesktop(bet.odds.length);
}

function getMatch(match) {
    if (match.avvRef == null) {
        return match;
    }

    const aggId = match.avvRef.sportId * -1;
    const ag = {idAggregata: aggId};
    const gruppoById = {};
    gruppoById[aggId] = ag;

    return {
        ...match,
        gruppiScommessa: [ag],
        pal: match.avvRef.pal,
        avv: match.avvRef.avv,
        sportRef: match.avvRef.sportId,
    };
}

function MoreBets(props) {
    const conf = getConfiguration();

    const match = getMatch(props.match);
    const isLive = match.isLive;

    const [macro, setMacro] = useState(null);
    const [agg, setAgg] = useState(() => {
        let firstAgg = match.avvRef ? match.avvRef.sportId * -1 : props.aggregata;
        if (firstAgg == null) {
            firstAgg = getPrincipaleOPrimoGruppo(match.gruppiScommessa).idAggregata;
        }
        return firstAgg;
    });

    const fetchMatch = match.isLive ? usePoll : useFetch;
    const [isLoading, isError, data] = fetchMatch(conf.api.getEvento, {
            pal: match.pal,
            avv: match.avv,
            idAggregata: agg,
            isLive
        },
        (data) => {
            return parseMatchData(data, agg, match, isLive, true);
        }
    );

    if (isLoading || isError || (match.isLive && !data)) {
        return (
            <div className="collapse-esiti-multipli collapse show">
                <Loader error={isError} />
            </div>
        );
    }

    if (match.isLive && !data.giocabilita) {
        return (
            <div className="collapse-esiti-multipli collapse show">
                <MessageInfo message={getLabel('general.giocabilita_chiusa')} />
            </div>
        );
    }

    function changeMacro(mg) {
        if (mg.id !== macro?.id) {
            let agg = null;
            if (!isLive && mg.id < 0) {
                agg = mg.aggregate.find(ag => ag.idAggregata < 0);
                if (agg) {
                    agg = agg.idAggregata;
                }
            }
            // Either we're in the live section or the bet group was not found.
            // We set the first bet group
            if (agg == null) {
                agg = mg.aggregate[0].idAggregata;
            }
            setMacro(mg);
            setAgg(agg);
        }
    }

    function changeAgg(aggId) {
        if (aggId !== agg) {
            setAgg(aggId);
        }
    }

    let selectedMacro = macro;
    if (data.macrogruppi.length > 0 && macro == null) {
        selectedMacro = getPrincipaleOPrimoGruppo(data.macrogruppi);
    }
    const aggs = selectedMacro != null ? selectedMacro.aggregate : data.gruppiScommessa;

    return (
        <div className="collapse-esiti-multipli collapse show">
            <div className="macro-gruppi margine-giu">
                {data.macrogruppi?.length > 1 &&          
                      <ButtonsContainer id={selectedMacro.id} aggregate={false}>
                        {data.macrogruppi.map(macroBtn =>
                            <div key={macroBtn.id} data-id={`m-${macroBtn.id}`} className={"bordo-tondo elemento-macro pointer elementoDropdown" + classIf(selectedMacro?.id === macroBtn.id, 'icona-selezionata')} onClick={() => changeMacro(macroBtn)}>
                                <p>{macroBtn.descrizione}</p>
                            </div>
                        )}
                    </ButtonsContainer>  
                }
                {aggs && 
                    <ButtonsContainer id={agg} aggregate={true}>
                        {aggs.map(aggBtn =>
                            <div key={aggBtn.idAggregata} data-id={`a-${aggBtn.idAggregata}`} className={"bg-bianco nero bordo-tondo elemento-macro pointer filter Zprincipali elementoDropdown" + classIf(aggBtn.idAggregata === agg, 'icona-selezionata')} onClick={() => changeAgg(aggBtn.idAggregata)}>
                                <p>{aggBtn.descrizione}</p>
                            </div>
                        )}
                    </ButtonsContainer>
                } 
            </div>
            <div className="quote-extra-partita">
                {data.bets.filter(bet => (bet.hasOdds)).map((bet, betIndex) => {
                    const odds = bet.odds.filter(odd => odd.value != null)
                    if (bet.isCompact && bet.dia?.length > 0) {
                        odds.sort((a, b) => a.rawValue - b.rawValue);
                    }
                    const betDesc = bet.dia?.length > 0 ? bet.desc : getBetDescription(bet, false, props.match?.sportRef);
                    return (
                        <React.Fragment key={bet.uniqueId}>
                            <div className="titolo-giocate-extra d-flex pointer allinea-sx padding-orizzontale padding-verticale bordo-tondo" data-toggle="collapse" href={"#barra-extra-" + bet.uniqueId} role="button">
                                <span>{betDesc}</span>
                                <div className="ml-2">
                                    <CashoutLabel bet={bet} />
                                </div>
                            </div>
                            <div className={"collapse tabella-quote-extra d-grid bg-grigio-chiaro padding-verticale show colonne-" + getColsNumber(bet)} id={"barra-extra-1-" + bet.uniqueId}>
                                {odds.map((odd, oddIndex) =>
                                    <MoreBetsOdd key={`${betIndex}_${oddIndex}`} {...odd} />
                                )}
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
}

export default MoreBets;